import HTTP_GESCOM from '../HTTP_GESCOM';

const URL_BASE = 'commun/ImageConnexion/';
const PROJET_NAME = 'AALV_HAVAS';

export default async function getImageConnexion() {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetImageConnexionAsync', {
    params: { projetName: PROJET_NAME },
  });
  return response;
}
